import type { ReactNode } from 'react';
import { Links, Meta, Scripts, ScrollRestoration } from 'react-router';
import { BaseLayout } from './components/layout/BaseLayout';
import ErrorPage from './pages/ErrorPage';
import './styles/index.css';

// Provides the full HTML document shell — runs outside React context (for error boundaries)
export function Layout({ children }: { children: ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="icon" type="image/svg+xml" href="/webIcon.svg" />
        <title>Alok Kumar - Portfolio</title>
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

// Global error boundary — catches route errors and future backend API errors
export { ErrorPage as ErrorBoundary };

// Root app component — delegates to BaseLayout for providers + UI shell
export default function App() {
  return <BaseLayout />;
}
